import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'ui-list-item-card',
  imports: [MatIconModule],
  templateUrl: './list-item-card.component.html',
  styleUrl: './list-item-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListItemCardComponent {
  hasEdit = input<boolean>(false);
  hasDelete = input<boolean>(false);

  edit = output<void>();
  remove = output<void>();
}
